import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { Input } from '@material-ui/core'
import QRCode from 'react-qr-code'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import InfoView from '~/components/views/InfoView/InfoView'
import { ReactComponent as Copy } from '~/assets/timeline/ic_copy.svg'
import { ReactComponent as Ok } from '~/assets/projects/import_ready.svg'
import { useQRCode } from './hooks/useQRCode'
import RawButton from '~/components/base/RawButton'
import './QRCode.scss'


export default function QRCodeComponent() {
  const { t, hideQRCodeDialog, qrValue, isError, token, isLoading } = useQRCode()
  const linkRef = useRef()
  const [ isCopy, setCopy ] = useState(false)

  const handleCopy = async () => {
    try {
      const textToCopy = linkRef.current?.value || ''
      await navigator.clipboard.writeText(textToCopy)
      setCopy(true)
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  useEffect(() => () => setCopy(false), [])

  return (
    <InfoView onHide={hideQRCodeDialog} className="qrcode">
      <Box width="100%" textAlign="center" marginBottom="25px" fontSize="14px" mt="10px">
        {t('QR_CODE_DIALOG_TITLE')}
      </Box>
      <Box display="flex" alignItems="center" justifyContent="center" mb="20px" minHeight={150}>
        {isLoading && <CircularProgress size={40} />}

        {isError && <Box color="error.main">{t('QR_CODE_LOAD_ERROR')}</Box>}

        {!isLoading && !isError && token && (
          <QRCode value={qrValue} size={150} />
        )}
      </Box>
      <Box display="flex" alignItems="center" justifyContent="center" className="qrcode__url-container">
        <Input inputRef={linkRef} type="text" value={qrValue} className={classNames('qrcode__link')} />
        <RawButton onClick={handleCopy} className={classNames('qrcode__button raw-button', isCopy ? 'active' : '')}>
          {isCopy ? <Ok /> : <Copy />}
        </RawButton>
      </Box>
    </InfoView>
  )
}
